import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mb-10" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h2", { class: "anchor fw-bolder mb-5" }, [
  /*#__PURE__*/_createVNode("a", { href: "#file-list-with thumbnail" }),
  /*#__PURE__*/_createTextVNode(" FileList with thumbnail ")
], -1)
const _hoisted_3 = { class: "rounded border p-10" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Click to upload")
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "el-upload__tip" }, " jpg/png files with a size less than 500kb ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_upload = _resolveComponent("el-upload")
  const _component_CodeHighlighter = _resolveComponent("CodeHighlighter")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("div", _hoisted_3, [
      _createVNode(_component_el_upload, {
        class: "upload-demo",
        action: "https://jsonplaceholder.typicode.com/posts/",
        "on-preview": _ctx.handlePreview,
        "on-remove": _ctx.handleRemove,
        "file-list": _ctx.fileList,
        "list-type": "picture"
      }, {
        tip: _withCtx(() => [
          _hoisted_5
        ]),
        default: _withCtx(() => [
          _createVNode(_component_el_button, {
            size: "small",
            type: "primary"
          }, {
            default: _withCtx(() => [
              _hoisted_4
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["on-preview", "on-remove", "file-list"]),
      _createVNode(_component_CodeHighlighter, {
        "field-height": 400,
        lang: "html"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.code5), 1)
        ]),
        _: 1
      })
    ])
  ]))
}